import React, { Component } from 'react';

import './styles.css';

import WarehouseComponent from '../Warehouses-small/Warehouses';

export default class Modal extends Component {
    constructor(props) {
        super(props)
        this.state = {
            sku: '',
            vendorNumber: '',
            warehouses: [],
            itemVendorMoq: '',
            itemVendorDcMoq: '',
            itemVendorMoqPerPO: ''
        }

        this.handleSkuChange = this.handleSkuChange.bind(this);
        this.handleVendorNumber = this.handleVendorNumber.bind(this);
        this.handleItemVendor = this.handleItemVendor.bind(this);
        this.handleItemVendorDc = this.handleItemVendorDc.bind(this);
        this.handleItemVendorMOQperPO = this.handleItemVendorMOQperPO.bind(this);
    }

    onClose = e => {
        if(this.state.sku !== '' || this.state.vendorNumber !== '' || this.state.itemVendorDcMoq !== '' || this.state.itemVendorMoq !== '' || this.state.warehouses.length > 0 
        || this.state.itemVendorMoqPerPO !== '') {
            this.props.onData(true);
        } else {
            this.props.onClose && this.props.onClose(e);
        }
       
    };

    closeModal = e => {
        this.props.onClose && this.props.onClose(e);
    }

    handleSkuChange(event) {
        const value = event.target.value;
        this.setState({sku: value});
    }

    handleVendorNumber(event) {
        const value = event.target.value;
        this.setState({vendorNumber: value});
    }

    handleItemVendor(event) {
        const value = event.target.value;
        this.setState({itemVendorMoq: value});
    }

    handleItemVendorDc(event) {
        const value = event.target.value;
        this.setState({itemVendorDcMoq: value});
    }

    handleItemVendorMOQperPO(event) {
        const value = event.target.value;
        this.setState({itemVendorMoqPerPO: value});
    }

    sendMOQ = () => {
        let object = JSON.parse(JSON.stringify(this.state));
        for(var key in object) {
            if(object[key] === "") {
                delete object[key];
            }
        }
        const data = {
            data: [object]
        }
        this.props.openNotification(true);
        this.props.onAddItemData(data);
        this.closeModal();
    }

    getWhses = (whses) => {
        const whsesString = whses.join(' ');
        this.setState({warehouses: whsesString})
    }

    cleanState() {
        this.setState({sku: '', vendorNumber: '', itemVendorMoqPerPO: '',itemVendorDcMoq: '', itemVendorMoq: '', warehouses: []});
    }


    render() {
        if(!this.props.show) {
            if(this.state.sku !== '' || this.state.vendorNumber !== '' || this.state.itemVendorDcMoq !== '' || this.state.itemVendorMoq !== '' || this.state.warehouses.length > 0 
            || this.state.itemVendorMoqPerPO !== '') {
               this.cleanState();
            }
            return null;
        }
        return (
            <div className="modal-background">
                <div className="modal-container">
                    <div className="modal-form">
                        <h2 className="modal-title">Add MOQ</h2>
                        <div className="modal-inputs-container">
                            <label htmlFor="item-number" className="modal-label">Item Number</label>
                            <input type="number" id="item-number" name="sku" className="input-modal" value={this.state.sku} onChange={this.handleSkuChange}/>
                        </div>
                        <div className="modal-inputs-container">
                            <label htmlFor="vendor-number" className="modal-label">Vendor Number</label>
                            <input type="number" id="vendor-number" name="vendorNumber" className="input-modal"  value={this.state.vendorNumber} onChange={this.handleVendorNumber}/>
                        </div>
                        <div className="modal-inputs-container">
                            <label htmlFor="warehouse" className="modal-label">Warehouse(s)</label>
                            <WarehouseComponent whsesData={this.getWhses}/>
                        </div>
                        <div className="modal-inputs-container">
                            <label htmlFor="nipo-cost" className="modal-label">Item Vendor MOQ</label>
                            <input type="number" id="nipo-cost" name="nipo-cost" className="input-modal"  value={this.state.itemVendorMoq} onChange={this.handleItemVendor}/>
                        </div>
                        <div className="modal-inputs-container">
                            <label htmlFor="order-pack" className="modal-label order-pack-label">Item Vendor Multiple</label>
                            <input type="number" id="order-pack" name="order-pack" className="input-modal"  value={this.state.itemVendorDcMoq} onChange={this.handleItemVendorDc}/>
                        </div>
                        <div className="modal-inputs-container">
                            <label htmlFor="per-po" className="modal-label per-po-label">Item Vendor Per PO</label>
                            <input type="number" id="per-po" name="per-po" className="input-modal"  value={this.state.itemVendorMoqPerPO} onChange={this.handleItemVendorMOQperPO}/>
                        </div>
                    </div>
                    <button type="button" className="btn btn-warning modal-return btn-sm" onClick={e => {this.onClose(e)}}>Return</button>
                    <button type="button" className="btn btn-warning btn-sm" onClick={this.sendMOQ}>Add</button>
                </div>



            </div>
            

        );
    }

}